import { checkIfVideoTypeLive } from "../../utils/liveVideoUtils";
import {
  getLiveConfigData,
  getUpdatedVideoData,
  handleForceSwitch
} from "../useLiveConfig";
import { checkForForceLoad } from "./utils";

export const handleLiveConfig = (
  liveConfigUrl,
  videoData,
  dispatchVideoApiEvent,
  videoApiUrl,
  domain,
  orcaRef,
  fallback
) => {
  getLiveConfigData(liveConfigUrl).then(liveConfigData => {
    const myConfig = liveConfigData[videoData._id] || {};
    if (checkForForceLoad(myConfig)) {
      const updatedVideoData = getUpdatedVideoData(
        liveConfigData,
        {},
        videoData
      );
      return handleForceSwitch(
        updatedVideoData,
        dispatchVideoApiEvent,
        videoApiUrl,
        domain,
        orcaRef
      );
    } else {
      fallback();
    }
  });
};

export const setOriginalVideo = ({
  type,
  videoData,
  liveConfigUrl,
  dispatchVideoApiEvent,
  videoApiUrl,
  domain,
  orcaRef
}) => {
  const emitEventToSetVideo = () => {
    dispatchVideoApiEvent({
      type,
      videoData
    });
  };
  // Before updating the videoData, check if we should force load from live config
  if (checkIfVideoTypeLive(videoData)) {
    handleLiveConfig(
      liveConfigUrl,
      videoData,
      dispatchVideoApiEvent,
      videoApiUrl,
      domain,
      orcaRef,
      emitEventToSetVideo
    );
  } else {
    emitEventToSetVideo();
  }
};
